import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { NavigationService } from 'src/app/services/navigation.service';
import {HelloAgainService} from '../../services/hello-again.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-map',
	templateUrl: './map.page.html',
	styleUrls: ['map.page.scss'],
})
export class MapPage {
	loadingHelloAgain = false;
	constructor(
		private navService: NavigationService,
		private router: Router,
		private helloAgainService: HelloAgainService,
		private translate: TranslateService
	) {}
	static url = 'map';
	static promoUrl = 'promo-code/:code';
	notShowLogo = AppComponent.hideLogo;
	static navigate(router: Router) {
		return router.navigateByUrl(MapPage.url);
	}
	goHome() {
		this.navService.home();
	}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	openUrl() {
		// window.location.assign('');
		const deviceType = this.getDeviceType();
		if (deviceType === 'Android' || deviceType === 'iOS') {
			window.location.assign('https://bit.ly/4b5EDGG');
		} else {
			window.location.assign('https://losteria.net/de/aktuelles/amici-club/');
		}
	}
	getDeviceType(): string {
		const userAgent = navigator.userAgent || navigator.vendor;

		// Check if the device is Android
		if (/android/i.test(userAgent)) {
			return 'Android';
		}

		// Check if the device is iOS
		if (/iPhone|iPad|iPod/i.test(userAgent)) {
			return 'iOS';
		}

		// If it is neither Android nor iOS, assume it is Desktop
		return 'Desktop';
	}
	async helloAgain() {
		if (!this.loadingHelloAgain) {
			this.loadingHelloAgain = true;
			await this.helloAgainService.runUserAuthorization();
			this.loadingHelloAgain = false;
		}
	}
	
	// Method to check if current language is French
	isCurrentLanguageFrench(): boolean {
		return this.translate.currentLang === 'fr';
	}
}
